
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'


export default {
name: "needpay",
components: {Cell, Group, Tab, TabItem},
data() {
return {
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
},
opid: localStorage.getItem('userid'),
payList: []
}
},
methods: {
needpay() {
this.$http.get('/api/v1/payments/' + this.opid + '/orders/user_list_repair_to_pay?role=INDV&payed=false&offset=0&count=10', this.header).then(response => {
console.log(response.data)
this.payList = response.data.content
})
},
yetpay() {
this.$http.get('/api/v1/payments/' + this.opid + '/orders/user_list_repair_to_pay?role=INDV&payed=true&offset=0&count=10', this.header).then(response => {
console.log(response.data)
this.payList = response.data.content
})
}
},
created() {
this.$http.get('/api/v1/payments/' + this.opid + '/orders/user_list_repair_to_pay?role=INDV&payed=false&offset=0&count=10', this.header).then(response => {
console.log(response.data)
this.payList = response.data.content
})
}
}



// WEBPACK FOOTER //
// ./src/components/Pay/needpay.vue